/**
 * <announcement-bar> — rotates message slides.
 * Attrs: rotate-interval (seconds), data-no-rotate, data-pause-on-hover
 */

class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
    this.index = Math.max(
      0,
      this.slides.findIndex((s) => s.classList.contains('is-active'))
    );
    this._timer = null;

    if (this.hasAttribute('data-no-rotate') || this.slides.length < 2) return;

    const sec = parseFloat(this.getAttribute('rotate-interval') || '4');
    this.intervalMs = Math.max(2, Number.isFinite(sec) ? sec : 4) * 1000;

    if (this.hasAttribute('data-pause-on-hover')) {
      this.addEventListener('mouseenter', this._onPause);
      this.addEventListener('mouseleave', this._onResume);
    }

    // Theme editor: restart when section reloads
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      this._onShop = () => {
        this.stop();
        this.slides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
        if (this.slides.length > 1 && !this.hasAttribute('data-no-rotate')) this.start();
      };
      document.addEventListener('shopify:section:load', this._onShop);
    }

    this.start();
  }

  disconnectedCallback() {
    this.stop();
    this.removeEventListener('mouseenter', this._onPause);
    this.removeEventListener('mouseleave', this._onResume);
    if (this._onShop) document.removeEventListener('shopify:section:load', this._onShop);
  }

  _onPause = () => this.stop();
  _onResume = () => this.start();

  start() {
    this.stop();
    if (this.slides.length < 2) return;
    this._timer = window.setInterval(() => this.next(), this.intervalMs);
  }

  stop() {
    if (this._timer != null) {
      window.clearInterval(this._timer);
      this._timer = null;
    }
  }

  next() {
    if (this.slides.length < 2) return;
    const prev = this.slides[this.index];
    this.index = (this.index + 1) % this.slides.length;
    const curr = this.slides[this.index];

    if (prev) {
      prev.classList.remove('is-active');
      prev.hidden = true;
    }
    if (curr) {
      curr.hidden = false;
      curr.classList.add('is-active');
    }
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar);
}
